import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

type BadgeTone = 'default' | 'success' | 'warning' | 'danger' | 'info' | 'gold' | 'neutral'

const toneClass: Record<BadgeTone, string> = {
  default: 'ui-badge-default',
  success: 'ui-badge-success',
  warning: 'ui-badge-warning',
  danger: 'ui-badge-danger',
  info: 'ui-badge-info',
  gold: 'ui-badge-gold',
  neutral: 'ui-badge-neutral',
}

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone
}

export function Badge({ children, className, tone = 'default', ...props }: BadgeProps) {
  return <span className={cn('ui-badge', toneClass[tone], className)} {...props}>{children}</span>
}
